export default __webpack_public_path__ + "static/rsz_gdansk-04799c4812ca65bbfb11e79b2de53607.png";